
(()=>{
const languageRoot=typeof document!=='undefined'?document.querySelector('[data-aa-wooden-shop],[data-aa-custom-wooden]'):null;
let language=languageRoot?JSON.parse(languageRoot.querySelector('[data-aa-i18n]').textContent):{};
function t(key,values={}){return String(language[key]??key).replace(/\{\{\s*(\w+)\s*\}\}/g,(_,name)=>String(values[name]??''));}
function setLanguage(value){language=value;}


const APPROVED_PRICING = Object.freeze({id:'normal',currency:'NZD',single:1750,bulkThreshold:7,bulkEach:1400,totals:Object.freeze({4:6500,5:8250,6:9000})});
const LABOUR_SALE_PRICING = Object.freeze({id:'labour-2026',currency:'NZD',single:1400,bulkThreshold:7,bulkEach:1100,totals:Object.freeze({4:4900,5:6000,6:7000})});
const LABOUR_SALE_WINDOW = Object.freeze({startsAt:'2026-10-19T11:00:00Z',endsAt:'2026-10-28T11:00:00Z',startsMs:Date.parse('2026-10-19T11:00:00Z'),endsMs:Date.parse('2026-10-28T11:00:00Z')});
function quantity(value, max=999) {
  const n=Number(value);
  if (!Number.isInteger(n)||n<1||n>max) throw new Error(t("s_93dab6ba31",{v0:(max)}));
  return n;
}
function estimatedTotal(count,pricing=APPROVED_PRICING) {
  if (!Number.isInteger(count)||count<0) throw new Error(t("s_95c4290ce9"));
  if (count>=pricing.bulkThreshold) return count*pricing.bulkEach;
  return pricing.totals[count]??count*pricing.single;
}
function priceLabel(cents){return money(cents).replace(/\.00$/,'');}
function pricingPreviewMode(){return null;}
function pricingContextAt(nowMs,previewMode=null){
 const simulated=['before','sale','after'].includes(previewMode);
 const effective=simulated?{before:LABOUR_SALE_WINDOW.startsMs-1,sale:LABOUR_SALE_WINDOW.startsMs+3600000,after:LABOUR_SALE_WINDOW.endsMs}[previewMode]:nowMs;
 const phase=Number.isFinite(effective)&&effective>=LABOUR_SALE_WINDOW.startsMs&&effective<LABOUR_SALE_WINDOW.endsMs?'sale':Number.isFinite(effective)&&effective<LABOUR_SALE_WINDOW.startsMs?'upcoming':'normal';
 const pricing=phase==='sale'?LABOUR_SALE_PRICING:APPROVED_PRICING;
 let notice=phase==='sale'?t("s_0853904f50"):phase==='upcoming'?t("s_9b712fdcd3"):'';
 return {phase,pricing,simulated,previewMode:simulated?previewMode:null,notice};
}
function nextPricingBoundaryAt(nowMs){return nowMs<LABOUR_SALE_WINDOW.startsMs?LABOUR_SALE_WINDOW.startsMs:nowMs<LABOUR_SALE_WINDOW.endsMs?LABOUR_SALE_WINDOW.endsMs:null;}
function pricingBetweenText(pricing){return t("s_8dd306465f")+priceLabel(estimatedTotal(5,pricing))+' · 7 coasters: '+priceLabel(estimatedTotal(7,pricing));}
function money(cents,currency='NZD') { return new Intl.NumberFormat('en-NZ',{style:'currency',currency}).format(cents/100); }
function normalized(value) {return String(value??'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();}
function matches(design,query,category=t("s_201d00c77b")) {
  return (category===t("s_201d00c77b")||design.category===category) && normalized([design.name,...design.internalNames].join(' ')).includes(normalized(query).trim());
}

function visibleDesigns(catalogue,query='',filter=t("s_201d00c77b")) {
  
  
  const coaster=catalogue.filter(d=>d.use==='functional'),display=catalogue.filter(d=>d.use==='display'),ordered=[];
  for(let i=0;i<Math.max(coaster.length,display.length);i+=2)ordered.push(...coaster.slice(i,i+2),...display.slice(i,i+2));
  ordered.push(...catalogue.filter(d=>!['functional','display'].includes(d.use)));
  return ordered.filter(d=>{
    const useMatches=filter===t("s_58267601d6")?d.use==='functional':filter===t("s_2a6230a455")?d.use==='display':true;
    return useMatches&&matches(d,query,[t("s_58267601d6"),t("s_2a6230a455")].includes(filter)?t("s_201d00c77b"):filter);
  });
}

function isPurchasableDesign(design) {return design?.purchaseEligible===true&&design?.purchasable===true&&Boolean(design?.variantId);}
function hydrateCatalogue(catalogue,product) {
  const variants=new Map((product?.variants??[]).map(v=>[String(v.id),v]));
  return catalogue.map(d=>{
    const v=variants.get(d.variantId);
    return {...d,available:!!v?.available,currentPriceCents:v?Number(v.price):null,verified:!!v};
  });
}
function validateFile(file,maxBytes=10*1024*1024) {
  if(!file) return null;
  const allowed={jpg:['image/jpeg'],jpeg:['image/jpeg'],png:['image/png'],webp:['image/webp'],pdf:['application/pdf']};
  const extension=file.name.toLowerCase().split('.').pop();
  if(!allowed[extension] || (file.type && !allowed[extension].includes(file.type))) return t("s_c6b85e2847");
  if(!file.size) return t("s_c6dcdda8d1");
  if(file.size>maxBytes) return t("s_296d422f5c");
  return null;
}
function lineProperties(line,selectionId) {
  const p={'Design':line.design.name,'Intended use':line.design.use==='display'?t("s_a7c29f9238"):t("s_da532dd0fd"),'_aa_selection_id':selectionId,'_aa_line_id':line.id};
  if(line.text) p['Engraving text']=line.text;
  if(line.instructions) p['Personalisation instructions']=line.instructions;
  if(line.personalised) p['Personalisation']=t("s_871e6cce9a");
  return p;
}
function reconcileLine(cart,line,selectionId) {
  const found=(cart?.items??[]).filter(i=>String(i.variant_id??i.id)===line.design.variantId && i.properties?._aa_selection_id===selectionId && i.properties?._aa_line_id===line.id);
  return {quantity:found.reduce((sum,i)=>sum+i.quantity,0), keys:found.map(i=>i.key)};
}
function publicProperties(properties) {return Object.entries(properties??{}).filter(([k,v])=>!k.startsWith('_')&&v);}

function isNZDContext(renderedCurrency,runtimeCurrency,cartCurrency,requireCart=false) {
  if(renderedCurrency!=='NZD')return false;
  if(runtimeCurrency&&runtimeCurrency!=='NZD')return false;
  if(requireCart&&cartCurrency!=='NZD')return false;
  if(cartCurrency&&cartCurrency!=='NZD')return false;
  return true;
}
function preservePreviewLink(target,currentHref,themeContext) {
  const current=new URL(currentHref),next=new URL(target,current);
  if(current.origin!==next.origin)return next.href;
  
  
  const queryTheme=current.searchParams.get('preview_theme_id');
  const renderedTheme=themeContext?.role==='unpublished'?String(themeContext.id??''):'';
  const valid=value=>typeof value==='string'&&/^[1-9]\d*$/.test(value);
  const theme=valid(queryTheme)?queryTheme:valid(renderedTheme)?renderedTheme:null;
  if(theme)next.searchParams.set('preview_theme_id',theme);
  const pricingMode=pricingPreviewMode(true,current.href);if(pricingMode)next.searchParams.set('aa_price_preview',pricingMode);
  return next.href;
}

function coasterCountLabel(count) {return t("s_0bd68159de",{v0:(count),v1:(count===1?'coaster':'coasters')});}
function trayFitsSection(sectionTop,sectionBottom,viewportHeight) {
  return sectionTop<viewportHeight && sectionBottom>viewportHeight+16;
}


const SELECTION_DRAFT_VERSION=1;
const SELECTION_DRAFT_TTL_MS=2*60*60*1000;
function selectionDraftAllowlist(catalogue,preview=false) {
 return new Set(catalogue.filter(d=>isPurchasableDesign(d)&&(preview||d.verified===true)).map(d=>d.variantId));
}
function selectionDraftKey(preview,themeId) {
 const id=/^[1-9]\d*$/.test(String(themeId??''))?String(themeId):'local';
 return `aa:wooden-selection:v1:${preview?'preview:'+id:'live'}`;
}
function decodeSelectionDraft(raw,allowed,now=Date.now()) {
 if(typeof raw!=='string'||raw.length>16384)return [];
 try{
  const draft=JSON.parse(raw);
  if(!draft||Array.isArray(draft)||Object.keys(draft).some(k=>!['version','expiresAt','items'].includes(k))||draft.version!==SELECTION_DRAFT_VERSION||!Number.isSafeInteger(draft.expiresAt)||draft.expiresAt<=now||draft.expiresAt>now+SELECTION_DRAFT_TTL_MS||!Array.isArray(draft.items)||draft.items.length>100)return [];
  const quantities=new Map();
  for(const item of draft.items){
   if(!item||Array.isArray(item)||Object.keys(item).some(k=>!['variantId','quantity'].includes(k))||typeof item.variantId!=='string'||!allowed.has(item.variantId)||!Number.isInteger(item.quantity)||item.quantity<1||item.quantity>999)continue;
   const n=(quantities.get(item.variantId)||0)+item.quantity;if(n>999)return [];
   quantities.set(item.variantId,n);
  }
  return [...quantities].map(([variantId,quantity])=>({variantId,quantity}));
 }catch{return [];}
}
function encodeSelectionDraft(items,allowed,now=Date.now()) {
 
 const clean=items.map(item=>({variantId:item.variantId,quantity:item.quantity}));
 const raw=JSON.stringify({version:SELECTION_DRAFT_VERSION,expiresAt:now+SELECTION_DRAFT_TTL_MS,items:clean});
 const normalized=decodeSelectionDraft(raw,allowed,now);
 if(clean.length&&(!normalized.length||clean.some(item=>!allowed.has(item.variantId)||!Number.isInteger(item.quantity)||item.quantity<1||item.quantity>999)))throw new Error(t("s_823ad48ea4"));
 return JSON.stringify({version:SELECTION_DRAFT_VERSION,expiresAt:now+SELECTION_DRAFT_TTL_MS,items:normalized});
}
function readSelectionDraft(getStorage,key,allowed,now=Date.now()) {
 try{return {ok:true,items:decodeSelectionDraft(getStorage().getItem(key),allowed,now)};}catch{return {ok:false,items:[]};}
}
function writeSelectionDraft(getStorage,key,items,allowed,now=Date.now()) {
 try{
  const storage=getStorage();
  if(!items.length){storage.removeItem(key);return storage.getItem(key)===null;}
  const raw=encodeSelectionDraft(items,allowed,now);storage.setItem(key,raw);return storage.getItem(key)===raw;
 }catch{return false;}
}


function isPrivateQATransport(config,theme){
 return config?.qaTransport===true&&String(theme?.id)==='152538054833'&&theme?.role==='unpublished';
}

function isCustomWoodVariant(id){return String(id??'')==='48057440108721';}


function mountScheduledPricing(root,config,env={window,document,performance}){
 const win=env.window,doc=env.document,perf=env.performance;
 const previewMode=pricingPreviewMode(config.preview===true&&config.qaTransport!==true&&win.Shopify?.theme?.role==='unpublished',win.location.href);
 let baseMs=Number.isFinite(config.serverNowUnix)&&config.serverNowUnix>0?config.serverNowUnix*1000:NaN;
 let baseMono=perf.now(),timer=null,syncing=false,disposed=false;
 const now=()=>baseMs+Math.max(0,perf.now()-baseMono);
 const context=()=>pricingContextAt(now(),previewMode);
 const canShow=()=>config.preview===true||isNZDContext(config.currency,win.Shopify?.currency?.active);
 function refresh(){
  if(disposed)return;
  const refreshMs=now(),state=pricingContextAt(refreshMs,previewMode),show=canShow();
  root.querySelectorAll('.aa-shipping-help').forEach(n=>{n.textContent=state.phase==='sale'?config.shippingHelpSale:config.shippingHelpNormal;});
  root.dataset.aaPricingPhase=state.phase;root.dataset.aaPricingSimulated=String(state.simulated);
  root.querySelectorAll('[data-aa-price-group]').forEach(n=>n.hidden=!show);
  root.querySelectorAll('[data-aa-pricing-schedule]').forEach(n=>{n.textContent=state.notice;n.hidden=!show||!state.notice;});
  root.querySelectorAll('[data-aa-price-total]').forEach(n=>{
   const count=Number(n.dataset.aaPriceTotal),valid=Number.isInteger(count)&&count>=0&&count<=999*46;
   n.hidden=!show||!valid;
   if(valid)n.textContent=(n.dataset.aaPricePrefix||'')+priceLabel(estimatedTotal(count,state.pricing))+(n.dataset.aaPriceSuffix||'');
  });
  root.querySelectorAll('[data-aa-price-bulk]').forEach(n=>{n.hidden=!show;n.textContent=priceLabel(state.pricing.bulkEach)+' each';});
  root.querySelectorAll('[data-aa-price-between]').forEach(n=>{n.hidden=!show;n.textContent=pricingBetweenText(state.pricing);});
  if(timer!==null)win.clearTimeout(timer);
  const boundary=previewMode?null:nextPricingBoundaryAt(refreshMs);
  const delay=Number.isFinite(boundary)?Math.max(1,Math.min(60000,boundary-now())):60000;
  timer=win.setTimeout(refresh,delay);
 }
 async function syncServerClock(){
  if(disposed||previewMode||syncing||!win.fetch)return;
  syncing=true;
  try{
   
   const response=await win.fetch(win.location.href,{method:'HEAD',cache:'no-store',credentials:'same-origin'});
   const serverMs=Date.parse(response.headers.get('date'));
   if(response.ok&&Number.isFinite(serverMs)){baseMs=serverMs;baseMono=perf.now();refresh();}
  }catch{}
  finally{syncing=false;}
 }
 const resume=()=>{refresh();void syncServerClock();};
 const visible=()=>{if(doc.visibilityState==='visible')resume();};
 win.addEventListener('pageshow',resume);win.addEventListener('focus',resume);doc.addEventListener('visibilitychange',visible);
 refresh();
 return {context,refresh,dispose:()=>{disposed=true;if(timer!==null)win.clearTimeout(timer);win.removeEventListener('pageshow',resume);win.removeEventListener('focus',resume);doc.removeEventListener('visibilitychange',visible);}};
}

if(typeof module==='object'&&module.exports)module.exports={setLanguage,quantity,estimatedTotal,pricingContextAt,nextPricingBoundaryAt,isNZDContext,validateFile,selectionDraftKey,decodeSelectionDraft,encodeSelectionDraft,isPrivateQATransport,isCustomWoodVariant,mountScheduledPricing};

(() => {
 if(typeof document==='undefined')return;
 const root=document.querySelector('[data-aa-custom-wooden]');if(!root)return;
 const config=JSON.parse(root.querySelector('[data-aa-custom-config]').textContent);
 const qaTransport=isPrivateQATransport(config,window.Shopify?.theme);
 const inertPreview=config.preview&&!qaTransport;
 const form=root.querySelector('form');if(!form)return;
 const text=form.querySelector('[name="properties[Engraving text]"]'),file=form.querySelector('input[type=file]'),feedback=root.querySelector('[data-aa-custom-feedback]'),button=form.querySelector('[type=submit]');
 const preview=root.querySelector('[data-aa-file-preview]');let objectUrl=null,checking=false;
 const currencyOK=()=>isNZDContext(config.currency,window.Shopify?.currency?.active);
 const gates=()=>isCustomWoodVariant(config.variantId)&&config.available&&config.priceCents===1750&&currencyOK()&&(qaTransport||(config.enabled&&config.pricingVerified&&config.packagingApproved&&config.fileUploadVerified));
 const pricingController=mountScheduledPricing(root,config);
 const quantityInput=form.querySelector('[name=quantity]'),quantityEstimate=form.querySelector('[data-aa-custom-estimate]');
 const refreshQuantityEstimate=()=>{try{quantityEstimate.dataset.aaPriceTotal=quantity(quantityInput.value);}catch{quantityEstimate.dataset.aaPriceTotal='invalid';}pricingController.refresh();};
 quantityInput.addEventListener('input',refreshQuantityEstimate);quantityInput.addEventListener('change',refreshQuantityEstimate);refreshQuantityEstimate();
 const readyLink=root.querySelector('[data-aa-ready-link]');if(readyLink){readyLink.href=preservePreviewLink(config.readyUrl||readyLink.href,window.location.href,window.Shopify?.theme);}
 button.disabled=inertPreview||!gates();
 if(inertPreview)feedback.textContent=t("s_0f92d48c13");
 
 else if(!currencyOK())feedback.textContent=t("s_485a5fb93a");
 else if(!config.available)feedback.textContent=t("s_3b0c8c08f1");
 else if(!gates())feedback.textContent=t("s_bdf40e9119");
 
 if(!config.preview&&!currencyOK())root.querySelectorAll('.aa-price-strip,.aa-price-between,.aa-price-note,.aa-shipping-offer,.aa-shipping-help,.aa-pricing-schedule,.aa-custom-estimate').forEach(n=>n.hidden=true);
 form.querySelector('[name="id"]').value=inertPreview?'':config.variantId||'';
 form.querySelector('[name="properties[_aa_line_id]"]').value=globalThis.crypto?.randomUUID?.()||`${Date.now()}-${Math.random().toString(36).slice(2)}`;
 file.addEventListener('change',()=>{
  const guide=root.querySelector('[data-aa-upload-guide]'),empty=root.querySelector('[data-aa-guide-empty]');const selected=file.files[0];const valid=!!selected&&!validateFile(selected);if(guide)guide.hidden=!valid;if(empty)empty.hidden=valid;
  preview.replaceChildren();if(objectUrl)URL.revokeObjectURL(objectUrl);objectUrl=null;const f=file.files[0];feedback.textContent=validateFile(f)||(inertPreview?t("s_de9f4c87d7"):t("s_117ed3a488"));
  if(f&&!validateFile(f)){const label=document.createElement('p');label.textContent=f.name;preview.append(label);if(f.type.startsWith('image/')){const image=document.createElement('img');objectUrl=URL.createObjectURL(f);image.src=objectUrl;image.alt=t("s_960e7cbd9b");image.className='aa-custom-slate-photo';image.style.maxHeight='none';preview.append(image);}}
 });
 form.addEventListener('submit',async event=>{
  event.preventDefault();if(checking)return;
  if(inertPreview||!gates()){feedback.textContent=inertPreview?t("s_3e5cdec0f6"):t("s_1f921e4752");return;}
  const error=validateFile(file.files[0]);
  if(error||(!text.value.trim()&&!file.files[0])){feedback.textContent=error||t("s_d93a52fbaf");return;}
  if(!form.reportValidity())return;
  checking=true;button.disabled=true;button.textContent=t("s_d789a8ec30");
  try{
   const base=(window.Shopify?.routes?.root||'/').replace(/\/?$/,'/');
   const liveResponse=await fetch(base+'products/personalised-wooden-coaster.js',{credentials:'same-origin',cache:'no-store',redirect:'error',headers:{Accept:'application/json'}});
   if(!liveResponse.ok)throw new Error(t("s_5de37382df"));
   const live=await liveResponse.json(),variant=(live.variants||[]).find(v=>String(v.id)==='48057440108721');
   if(String(live.id)!=='9172398997681'||live.handle!=='personalised-wooden-coaster'||!variant?.available||variant.price!==1750)throw new Error(t("s_db86213d3d"));
   quantity(quantityInput.value);
   const response=await fetch(base+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}});
   if(!response.ok)throw new Error(t("s_11808a525b"));
   const cart=await response.json();
   if(!isNZDContext(config.currency,window.Shopify?.currency?.active,cart.currency,true))throw new Error(t("s_0b7c89486b"));
   if(!gates())throw new Error(t("s_b15e9cce60"));
   form.action=base+'cart/add';
   button.textContent=t("s_e1da296a6a");
   HTMLFormElement.prototype.submit.call(form);
  }catch(error){feedback.textContent=error.message;checking=false;button.disabled=!gates();button.textContent=t("s_a043c9548c");}
 });
 window.addEventListener('pageshow',event=>{if(event.persisted){refreshQuantityEstimate();checking=false;button.disabled=inertPreview||!gates();button.textContent=t("s_a043c9548c");}});
})();

})();